<n-panel height="100%">
    <div class="poweronfail">
        <div class="poweronfail-icon">
            <svg>
                <use xlink:href="#app-icon-something-wrong"></use>
            </svg>
            <div class="poweronfail-title">
                <h1>{{i18n.poweronFailTitle}}</h1>
            </div>
        </div>
        <div class="poweronfail-split mt-10">
        </div>
        <div class="poweronfail-content">
            <n-kv>
                <n-kv-item [key]="i18n.errorCodeTitle">
                    <div style="width: 5.6rem">
                        {{failReason.code}}
                    </div>
                </n-kv-item>
                <n-kv-item class="mt-10" [key]="i18n.resonTitle">
                    <div style="width: 5.6rem">
                        {{failReason.reason}}
                    </div>
                </n-kv-item>
                <n-kv-item class="mt-10" [key]="i18n.suggestionTitle">
                    <div style="width: 5.6rem">
                        {{failReason.suggestion}}
                    </div>
                </n-kv-item>
                <n-kv-item class="poweronfail-export mt-10" [key]="i18n.downLoadLogTitle">
                    <div class="mt-10">
                        <button nButton type="text"
                            [icon]="i18n.downloadRecentIcon"
                            [label]="i18n.recentLogTitle"
                            [disabled]="initPasswordFail"
                            [disabledTips]="i18n.poweronFailDisableTip"
                            (click)="download('recent')">
                        </button>
                        <button nButton type="text"
                            class="ml-10"
                            [icon]="i18n.downloadAllIcon"
                            [label]="i18n.allLogTitle"
                            [disabled]="initPasswordFail"
                            [disabledTips]="i18n.poweronFailDisableTip"
                            (click)="download('all')">
                        </button>
                    </div>
                </n-kv-item>
            </n-kv>
        </div>
        <div class="poweronfail-jump">
            <div class="mt-20">
                <button pButton
                    style="margin-left: auto;width: 1.5rem"
                    class="ui-btn-primary"
                    [label]="i18n.jumpToLoginPageTitle"
                    (click)="jumpToLoginPage()"
                    id="jump-to-login-page-btn">
                </button>
            </div>
        </div>
    </div>
</n-panel>
